import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, forkJoin, last, Observable, tap } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { AdminHttpProxyService } from './shared/services/admin-http-proxy.service';
import { AdminLoginService } from './shared/services/admin-login.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '../../../environments/environment';
import * as ADMIN_CONSTANT from '../../shared/constants/admin-constants';
import { NotificationService } from './shared/services/notification.service';

declare var $: any;
declare let ga: Function;

const DEFAULT_UI_VERSION = 'V2';

@Injectable({
  providedIn: 'root',
})
export class AdminAppInitializerService {
  cloudDomain: any;
  private cloudHeader: any;
  public configDetailsData: any;
  public tenants: any;
  public APIContext: any;
  public SpendAPIContextId: any;
  tenantFound: boolean = false;
  spendTenantFound: boolean = false;
  public cloudContextTenants: any;
  cloudContextTenents: any;
  appName: string;
  PropertyData: any;
  propertyConfigData: any;
  tenantId: string;
  propertyId: string;
  tourData: any;
  PaymentIframeUrl: string;
  languageLocals: any;
  currency: any;
  countryCode: any;
  zone: any;
  digitalKeyLocation: any;
  pms: string;
  seatWidgetUrl: any;
  langId: any;
  serviceHeaders: any = {
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
  };
  private currencyUri: string = 'wbe-property-service/baseCurrencyList';
  private tenentCurrencyUri: string = 'wbe-property-service/tenantPropCurrencyDetail';
  private propertyname_offer: string = '';
  private assetsURL: string;
  private servername_offer: String = 'wbe-property-service/offerDetail';
  public configUrl: string = 'wbe-property-service/property';
  public golfIntervalUrl: string = 'wbe-property-service/golftimeinterval';
  public seatUrl: string = 'wbe-property-service/seatRestaurantDetails';
  public imageUploadUrl: string = 'wbe-admin-service/';
  public spaUrl: string = 'wbe-spa-service/spa';
  public kioskUrl: string = 'wbe-kiosk-service/cico';
  public kioskPayAgentUrl: string = 'wbe-kiosk-service/payagent';
  public golfUrl: string = 'wbe-golf-service/golf';
  public digitalKeyUrl: string = 'wbe-digitalkey-service';
  public spaServiceHeaders: any;
  public golfServiceHeaders: any;
  public onlineStatusSubject = new BehaviorSubject<any>('default');
  casinoSystemTypeFields: any;
  webMetricUrl: any = 'wbe-metrics-service/metrics';
  webRoomMetricUrl: any = 'wbe-metrics-service/room-metrics';
  webDineMetricUrl: any = 'wbe-metrics-service/dine-metrics';
  webGolfMetricUrl: any = 'wbe-metrics-service/golf-metrics';
  webSpaMetricUrl: any = 'wbe-metrics-service/spa-metrics';
  webBookUrl: any = 'wbe-book';
  public upsellConfigFields: any;

  // appNameList for MultiSync Configuration Fields

  public uiVersion = new BehaviorSubject<string>(DEFAULT_UI_VERSION);
  appNameList: any = ['wbe', 'spa', 'golf', 'seat', 'unit', 'giftcard', 'snc', 'upsell'];

  public appDropDownList: any = [];
  public propertyService: string = 'wbe-property-service';
  public azureBlobTokenKey: any = '';
  public admin_service = 'wbe-admin-service/';
  public appNameOrder = ['wbe', 'spa', 'golf', 'seat', 'unit', 'giftcard', 'snc', 'upsell'];
  public propertyInfo: any;
  azureStorageUrl: string = environment.azureAccountUrl;
  public defaultLanguages: string[] = [];
  public kioskAzureBlobTokenKey = '';
  private kioskAzureBlobToken = new BehaviorSubject<string | null>(null);
  public kioskAzureBlobToken$ = this.kioskAzureBlobToken.asObservable();
  private clearDataRead: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public clearDataRead$: Observable<boolean> = this.clearDataRead.asObservable();
  public updatedProductPermissions: any;
  public propertyContextSubject: BehaviorSubject<string> = new BehaviorSubject('default');
  public propertyContextSubject$: Observable<string> = this.propertyContextSubject.asObservable();
  contextIdAssigned: boolean = false;
  public cloudBackendDomain: string = environment.backendApiUrl;

  constructor(
    private http: HttpClient,
    public httpService: AdminHttpProxyService,
    public loginService: AdminLoginService,
    public snackbar: MatSnackBar,
    private notificationService: NotificationService
  ) {}

  public getCloudDomain() {
    return this.cloudDomain;
  }

  public getCloudDomainName = function () {
    // let hostName = document.location.hostname;
    // if (hostName != 'localhost') {
    //   return window.location.protocol + '//' + hostName;
    // } else {
    return environment.backendApiUrl;
    // }
  };

  public getCloudHeader() {
    return this.cloudHeader;
  }

  public getContextTenents() {
    return this.cloudContextTenants;
  }

  getServerAssetsURL = function () {
    return this.assetsURL;
  };

  getpropertyDetails_offer = function () {
    return this.propertyname_offer;
  };

  getserverDetails_offer = function () {
    return this.servername_offer;
  };

  gettenantId = function () {
    return this.tenantId;
  };

  getCurrencyURI = function () {
    return this.currencyUri;
  };

  getTenentCurrencyURI = function () {
    return this.tenentCurrencyUri;
  };

  getGolfTimeInterval = function () {
    return this.golfIntervalUrl;
  };

  checkDomain() {
    if (!environment.showLogs) {
      if (window) {
        window.console.log = function () {};
      }
    }
  }

  processConfig(data) {
    let tenantId;
    let propertyId;
    let url;

    if (this.cloudDomain) {
      this.checkDomain();
    }

    const logindata = JSON.parse(sessionStorage.getItem('adminPortalLoginData'));
    let st = sessionStorage.getItem('tenant');
    let sp = sessionStorage.getItem('propertyId');
    if (st && sp) {
      tenantId = st;
      propertyId = sp;
    } else {
      tenantId = logindata.tenantId;
      propertyId = logindata.propertyId;
    }

    console.log('environment.backendApiUrl', environment.backendApiUrl);

    // Spend
    const validateUrl = `${environment.backendApiUrl}/wbe-spend-admin-service/siteConfig/tenants/${tenantId}/propertyId/${propertyId}/validate`;
    this.httpService.get(validateUrl).subscribe(
      (validateResponse) => {
        if (validateResponse?.success) {
          this.spendTenantFound = true;
          this.SpendAPIContextId = validateResponse.contextId;
        } else {
          this.spendTenantFound = false;
        }
      },
      (error) => {
        this.spendTenantFound = false;
      }
    );

    url =
      environment.backendApiUrl + '/' + this.configUrl + '/tenants/' + tenantId + '/propertyId/' + propertyId + '/appName/' + this.appName;

    this.httpService.get(url).subscribe((response) => {
      let datares;
      datares = response;
      if (datares.Success) {
        this.tenantFound = true;
        this.PropertyData = response;
        this.updatedProductPermissions = this.PropertyData.permissions;
        this.propertyConfigData = this.PropertyData.PropNameKeyList;
        this.APIContext = this.PropertyData['ContextId'];
        if (this.PropertyData && this.PropertyData.rGuestBookUIVersion) this.uiVersion.next(this.PropertyData.rGuestBookUIVersion);
        else this.uiVersion.next(DEFAULT_UI_VERSION);
        this.tenantId = tenantId;
        this.propertyId = propertyId;
        this.setPMS(this.PropertyData.pms);
        data();
      } else {
        this.tenantId = tenantId;
        this.propertyId = propertyId;
        this.tenantFound = false;
        data();
      }
      return false;
    });
  }

  setTenantFound() {
    this.tenantFound = true;
    this.processConfig(() => {
      this.siteLoading('');
    });
  }

  setSpendTenantFound() {
    this.spendTenantFound = true;
  }

  setPMS(pms: string) {
    this.pms = pms;
  }

  async resolve(route: ActivatedRouteSnapshot) {
    this.appName = route.data['type'];
    console.log('appName', this.appName);
    this.notificationService.requestNotificationPermission();
    return new Promise(async (resolve, reject) => {
      this.checkDomain();
      if (this.appName === 'unit') {
        await this.bindMapApiKey(this.tenantId);
        await this.getAllPropertyInfo();
      } else if (this.appName === 'propertysettings') {
        await this.getAllPropertyInfo();
      }

      let azure = await this.getAzureBlobToken();
      let kioskKey = await this.getAzureBlobTokenKiosk();
      if (this.azureStorageUrl == '') {
        this.azureStorageUrl = 'https://rguestbookexpressprod.blob.core.windows.net';
      }
      this.http.get(ADMIN_CONSTANT.DEFAULT_JSON_PATH.casinoSystemType).subscribe((response) => {
        this.casinoSystemTypeFields = response;
      });
      this.http.get(ADMIN_CONSTANT.DEFAULT_JSON_PATH.upsellConfig).subscribe((res) => {
        this.upsellConfigFields = res;
      });

      this.http.get(ADMIN_CONSTANT.DEFAULT_JSON_PATH.languageLocals).subscribe((response) => {
        this.languageLocals = response;
      });

      this.http.get(ADMIN_CONSTANT.DEFAULT_JSON_PATH.currency).subscribe((response) => {
        this.currency = response;
      });

      this.http.get(ADMIN_CONSTANT.DEFAULT_JSON_PATH.zone).subscribe((response) => {
        this.zone = response;
      });

      this.http.get(ADMIN_CONSTANT.DEFAULT_JSON_PATH.digitalKeyLocation).subscribe((response) => {
        this.digitalKeyLocation = response;
      });

      this.http.get(ADMIN_CONSTANT.DEFAULT_JSON_PATH.countryCode).subscribe((response) => {
        this.countryCode = response;
      });

      this.processConfig(() => {
        let tourDataUrl: string = ADMIN_CONSTANT.DEFAULT_JSON_PATH.tourData.replace('appname', this.appName);
        this.http.get(tourDataUrl).subscribe((response) => {
          this.tourData = response;
          if (!(this.appName == 'spa' || this.appName == 'golf')) resolve(true);
          else {
            console.log('get headers of golh');
            switch (this.appName) {
              case 'spa':
                this.getspaPropheaders();
                break;
              case 'golf':
                this.getgolfPropInfo();
                break;
            }
            resolve(true);
          }
          var preloader = document.querySelector('.preloaderapp');
          if (preloader) {
            preloader.className = ' preloaderapp-hidden-add preloaderapp-hidden-add-active';
          }
        });
      });
    });
  }

  async getAzureBlobToken() {
    let url = environment.backendApiUrl + '/' + this.admin_service + 'generateAzureBlobStorageSAS';
    let tokenResponse: any = await this.httpService.get(url).toPromise();
    if (tokenResponse.success) {
      if (!this.azureBlobTokenKey) {
        setInterval(() => {
          this.getAzureBlobToken();
        }, 55 * 60 * 1000);
      }
      this.azureBlobTokenKey = tokenResponse.token;
    }
  }

  async getAzureBlobTokenKiosk() {
    let url = `${environment.backendApiUrl}/${this.admin_service}kiosk/generateAzureBlobStorageSAS`;
    let tokenResponse: any = await this.httpService.get(url).toPromise();
    if (tokenResponse.success) {
      if (!this.kioskAzureBlobTokenKey) {
        setInterval(() => {
          this.getAzureBlobTokenKiosk();
        }, 55 * 60 * 1000);
      }
      this.kioskAzureBlobTokenKey = tokenResponse.token;
      this.kioskAzureBlobToken.next(tokenResponse.token);
    }
  }

  async getgolfPropInfo() {
    console.log('get golf headers');
    try {
      let res = await this.getGolfPropInfo().toPromise();
      if (res && res.success && res.golfHeader) {
        this.golfServiceHeaders = {
          headers: res.golfHeader,
        };
      }
    } catch (err) {
      console.log('err getting headers');
    }
  }

  async getspaPropheaders() {
    console.log('get golf headers');
    try {
      let res = await this.getSpaPropInfo().toPromise();
      if (res && res.success && res.spaHeader) {
        this.spaServiceHeaders = {
          headers: res.spaHeader,
        };
      }
    } catch (err) {
      console.log('err getting headers');
    }
  }

  getSpaPropInfo(): Observable<any> {
    let spaPropUrl =
      environment.backendApiUrl + '/' + this.spaUrl + '/tenants/' + this.tenantId + '/propertyId/' + this.propertyId + '/propertyInfo';
    return this.httpService.get(spaPropUrl);
  }

  getGolfPropInfo(): Observable<any> {
    let golfPropUrl =
      environment.backendApiUrl + '/' + `${this.golfUrl}/tenants/${this.tenantId}/propertyId/${this.propertyId}/propertyInfo`;
    return this.httpService.get(golfPropUrl);
  }

  siteLoading(text) {
    console.log('preload text', text);
    text ? $('#preloaderAdmin').css('display', 'block') : $('#preloaderAdmin').css('display', 'none');
    $('#preloaderAdminText').html(text);
  }
  setLangId(langId) {
    this.langId = langId;
  }
  getLangId() {
    return this.langId;
  }

  async bindMapApiKey(tenantId) {
    try {
      let res = await this.loginService.getMapAPIKey(tenantId).toPromise();
      if (res.Success && res.azureDetails && res.azureDetails.accountKey) {
        // Adding google maps API key
        let node = document.createElement('script');
        node.src = `https://maps.googleapis.com/maps/api/js?key=${res.azureDetails.accountKey}&libraries=places`;
        node.type = 'text/javascript';
        node.async = true;
        node.charset = 'utf-8';
        node.id = 'api-key-attached';
        let element = document.getElementById('api-key-attached');
        if (!element) {
          document.getElementsByTagName('head')[0].appendChild(node);
          console.log('API-key-attached');
        }
      }
    } catch (err) {
      console.log('err getting google api key');
    }
  }

  checkForProducts(list) {
    let appList = [];
    list.forEach((element) => {
      switch (element) {
        case 'book':
          if (this.propertyInfo['wbe'] && this.propertyInfo['wbe'].online) appList.push('/wbe/offers');
          break;
        case 'spa':
          if (this.propertyInfo['spa'] && this.propertyInfo['spa'].online) appList.push('/spa/services');
          break;
        case 'golf':
          if (this.propertyInfo['golf'] && this.propertyInfo['golf'].online) appList.push('/golf/courses');
          break;
        case 'seat':
          if (this.propertyInfo['seat'] && this.propertyInfo['seat'].online) appList.push('/seat/restaurantsList');
          break;

        default:
          break;
      }
    });
    appList.push('Others');
    return appList;
  }
  async getAllPropertyInfo() {
    let serviceList = [];
    this.appNameOrder.forEach((appName) => {
      serviceList.push(this.getPropertyConfigData(appName));
    });
    serviceList.length > 0 &&
      forkJoin(serviceList).subscribe((resArr: any) => {
        let propertyInfo = {};
        resArr.forEach((r, i) => {
          if (!r.Success) return;
          propertyInfo[this.appNameOrder[i]] = r;
        });
        this.propertyInfo = propertyInfo;
        this.onlineStatusSubject.next(this.propertyInfo);
        console.log(this.propertyInfo);
      });
  }

  // Get full property config with appName - used in propertylevel section - general settings
  getPropertyConfigData(appName) {
    const domain = this.getCloudDomainName();
    const logindata = JSON.parse(sessionStorage.getItem('adminPortalLoginData'));
    let st = sessionStorage.getItem('tenant');
    let sp = sessionStorage.getItem('propertyId');
    let tenantId = '';
    let propertyId = '';
    if (st && sp) {
      tenantId = st;
      propertyId = sp;
    } else {
      tenantId = logindata.tenantId;
      propertyId = logindata.propertyId;
    }
    const url = `${
      environment.backendApiUrl
    }/wbe-property-service/property/tenants/${tenantId}/propertyId/${propertyId}/appName/${appName}?${Date.now()}`;
    return this.httpService.get(url).pipe(
      tap((data: any) => {
        console.log(data);
        if (data.ContextId && !this.contextIdAssigned) {
          this.propertyContextSubject.next(data.ContextId);
          this.contextIdAssigned = true;
        }
      })
    );
  }

  onError(e?) {
    this.siteLoading('');
    let error = '';
    if (e && typeof e === 'string') error = e;
    else error = e?.errorMessage || e?.error?.errorMessage || 'Unknown error occured';
    this.showError(error);
  }

  showError(err) {
    this.snackbar.open(err, '', {
      duration: 3000,
    });
  }

  updateClearDataRead(value: boolean): void {
    this.clearDataRead.next(value);
  }
}
